import { makeStyles } from 'tss-react/mui';

export const useCancelModalStyles = makeStyles({ name: 'cancel-session-modal' })(theme => ({
  content: {
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    padding: theme.spacing(3),
  },
}));
